import { jsx } from 'react/jsx-runtime';
import { useResourceDataContextSafe } from '../../../../../resource-detail/components/context/resourceDataContext.js';
import { styled } from 'styled-components';
import { IconBookmark } from '@fabric-app/icons/svg';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Image } from '@fabric-app/ui/components/Image';

const ResourcePreviewListItemImage = () => {
  const { resource, placeholderName } = useResourceDataContextSafe();
  return resource.thumbnail?.sm ? /* @__PURE__ */ jsx(ThumbnailImage, {
    src: resource.thumbnail?.sm,
    alt: resource.name || placeholderName,
    draggable: false
  }) : /* @__PURE__ */ jsx(IconBookmark, {
    style: {
      width: "1rem",
      height: "1rem"
    }
  });
};
const ThumbnailImage = styled(Image).withConfig({
  displayName: "ResourcePreviewListItemImage__ThumbnailImage",
  componentId: "sc-308e780a-0"
})([
  `width:100%;flex-grow:1;max-height:24px;object-fit:contain;display:block;border-radius:0.25rem;background:`,
  `;`
], cssVar["color-bg-section"]);

export { ResourcePreviewListItemImage };
//# sourceMappingURL=ResourcePreviewListItemImage.js.map
